module.exports = __webpack_public_path__ + "static/media/you_glasses 4.c2ac1268.png";